import {keymap} from '@milkdown/prose/keymap';
import {liftEmptyBlock} from '@milkdown/prose/commands';

export function createBetterBackspacePlugin() {
    return keymap({
        Backspace: (state, dispatch) => {
            const {selection, storedMarks, schema} = state;
            const {$from, empty} = selection;

            if (!empty) {
                return false;
            }

            const parent = $from.parent;
            const isEmptyBlock = parent.content.size === 0;

            // We only customise behaviour for *empty* blocks.
            if (!isEmptyBlock) {
                return false;
            }

            // 1) Empty CODE BLOCK → convert to plain paragraph
            if (parent.type.spec.code) {
                const paragraphType = schema.nodes.paragraph;
                if (!paragraphType || !dispatch) {
                    return false;
                }

                // Parent is the code block node itself
                const depth = $from.depth;
                const from = $from.before(depth); // position before parent
                const to = from + parent.nodeSize;

                const tr = state.tr.replaceWith(from, to, paragraphType.create());
                dispatch(tr.scrollIntoView());
                return true;
            }

            // 2) Empty paragraph inside a single-child BLOCKQUOTE
            //    > |
            //    Backspace → plain empty paragraph
            if ($from.depth > 0) {
                const depth = $from.depth;
                const grand = $from.node(depth - 1);

                if (grand.type.name === 'blockquote' &&
                    grand.childCount === 1 &&
                    grand.firstChild === parent
                ) {
                    const paragraphType = schema.nodes.paragraph;
                    if (!paragraphType || !dispatch) {
                        return false;
                    }

                    const from = $from.before(depth - 1); // before blockquote
                    const to = from + grand.nodeSize;

                    const tr = state.tr.replaceWith(from, to, paragraphType.create());
                    dispatch(tr.scrollIntoView());
                    return true;
                }
            }

            // 3) Generic: try ProseMirror's liftEmptyBlock for
            //    other empty textblocks (e.g. headings inside lists)
            if (liftEmptyBlock(state, dispatch)) {
                return true;
            }

            // 4) Empty paragraph with stored marks (bold/italic/strike/etc.)
            //    → clear formatting so it doesn't "stick"
            if (storedMarks && storedMarks.length > 0) {
                if (dispatch) {
                    const tr = state.tr.setStoredMarks([]);
                    dispatch(tr);
                }
                return true;
            }

            // Let other keymaps handle Backspace if none of the above matched.
            return false;
        },
    });
}
